// extracted by mini-css-extract-plugin
export default {"controls":"F4uXtHvbTxMiDTw3dW6g","help":"DvtHyh6ro_XERqYDOXhQ","copy":"rccOk8NHkCdIHIJsFB6N"};